import React, {useEffect, useState} from "react"
import {Col, Container, Row} from 'react-bootstrap'
import "./dashboard-topbar.scss"
import NotificationModal from "../../common/modals/notification-modal/NotificationModal";
import ProfileDropdown from "./profile/ProfileDropdown";
import Dropdown from 'react-bootstrap/Dropdown';
import {DropdownArrowIcon} from "../../../../assets/icons/defaultIcons";
import {HiOutlineMenu} from "react-icons/hi";
import {useUser} from "../../../providers/UserContext";
import {UserAuthService} from "../../../services/user-auth-api.service";
import userIcon from "../../../../assets/images/user.png";
import HeadingSkeleton from "../../skeletons/HeadingSkeleton";

const DashboardTopbar =  React.forwardRef(({ref1,ref2,ref3,ref4,setCollapsed, collapsed }, ref) => {
    const [profileData, setProfileData] = useState(false)
    const [showProfile, setShowProfile] = useState();
    const {user} = useUser()
    const [loader, setLoader] = useState(false)
    const {setProfileUpdate , profileUpdate} = useUser()

    async function GetProfileData() {
        setLoader(true)
        const response = await UserAuthService.getProfileData();

        if(response?.data?.data?.status){
            setProfileData(response.data?.data?.data?.user)
            setLoader(false)
        }
    }

    useEffect(()=>{
        GetProfileData()
    },[ profileUpdate])


    return(
        <div className={'dashbaord-topbar'}>
            <Container fluid className={'h-100'}>
                <Row className={'h-100'}>
                    <Col className={'h-100 d-flex align-items-center gap-10'} className={'d-flex align-items-center'} xs={4} sm={4} md={4}>
                        <span className={'sidebar-action-btn'} onClick={() => setCollapsed(!collapsed)}>
                             <HiOutlineMenu />
                         </span>
                        {/*<div className={'dashboard-filter'}>*/}
                        {/*    <SearchField searchData={searchData}/>*/}
                        {/*</div>*/}
                    </Col>
                    <Col className={'h-100'} md={8} sm={8} xs={8}>
                        <div className={'topbar-actions'} >
                            <div className={'d-flex gap-5'}>
                            </div>
                            {
                                loader ? <HeadingSkeleton height={30} maxWidth={100}/>
                                :
                                    <Dropdown>
                                        <Dropdown.Toggle id="dropdown-basic">
                                            <div className={'profile-dropdown-btn'} ref={ref3}>
                                                <div className={'profile-avatar'}>
                                                    <img src={profileData?.profileImage ? profileData?.profileImage : userIcon} className={'img-fluid'}/>
                                                </div>
                                                <div className={'profile-details'}>
                                                    <h5>{profileData?.fullName}</h5>
                                                    <DropdownArrowIcon/>
                                                </div>
                                            </div>
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            <Dropdown.Item href="#/action-1">
                                                <ProfileDropdown/>
                                            </Dropdown.Item>

                                        </Dropdown.Menu>
                                    </Dropdown>
                            }


                        </div>
                    </Col>
                </Row>
            </Container>

            <NotificationModal
                show={showProfile}
                close={setShowProfile}
                content={<ProfileDropdown close={setShowProfile}/>}
            />
        </div>
    )
})

export default DashboardTopbar